interface ComponentProps {
	title: string;
	subtitle?: string;
	style?: React.CSSProperties;
	titleStyle?: React.CSSProperties;
	subtitleStyle?: React.CSSProperties;
}

function ComponentHeader({ title, subtitle, style, titleStyle, subtitleStyle }: ComponentProps) {
	return (
		<div style={style}>
			<h5 style={{ fontWeight: 500, ...titleStyle }}>{title}</h5>
			<p style={{ color: '#555', ...subtitleStyle }}>{subtitle}</p>
		</div>
	);
}

export default ComponentHeader;
